/**
 * Redux store for generic Java Lab state.
 */
var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    isRunning: false,
    isTesting: false,
    backpackEnabled: false,
    isStartMode: false,
    levelName: undefined,
    isReadOnlyWorkspace: false,
    hasOpenCodeReview: false,
    isCommitSaveInProgress: false,
    hasCommitSaveError: false,
    validationPassed: false,
    hasRunOrTestedCode: false,
    isJavabuilderConnecting: false,
};
var javalabSlice = createSlice({
    name: 'javalab',
    initialState: initialState,
    reducers: {
        setIsRunning: function (state, action) {
            state.isRunning = action.payload;
        },
        setIsTesting: function (state, action) {
            state.isTesting = action.payload;
        },
        setBackpackEnabled: function (state, action) {
            state.backpackEnabled = action.payload;
        },
        /**
         * We should move isStartMode and levelName into a separate level redux file,
         * or convert this design to one more closely matching redux/applab. When we
         * do, we can remove the special treatment of Javalab in ImagePicker.jsx that
         * enables the Asset Manager to run.
         */
        setIsStartMode: function (state, action) {
            state.isStartMode = action.payload;
        },
        setLevelName: function (state, action) {
            state.levelName = action.payload;
        },
        setIsJavabuilderConnecting: function (state, action) {
            state.isJavabuilderConnecting = action.payload;
        },
        setIsReadOnlyWorkspace: function (state, action) {
            state.isReadOnlyWorkspace = action.payload;
        },
        setHasOpenCodeReview: function (state, action) {
            state.hasOpenCodeReview = action.payload;
        },
        setCommitSaveStatus: function (state, action) {
            state.isCommitSaveInProgress = action.payload.isCommitSaveInProgress;
            state.hasCommitSaveError = action.payload.hasCommitSaveError;
        },
        setValidationPassed: function (state, action) {
            state.validationPassed = action.payload;
        },
        setHasRunOrTestedCode: function (state, action) {
            state.hasRunOrTestedCode = action.payload;
        },
    },
});
export var setIsRunning = (_a = javalabSlice.actions, _a.setIsRunning), setIsTesting = _a.setIsTesting, setBackpackEnabled = _a.setBackpackEnabled, setIsStartMode = _a.setIsStartMode, setLevelName = _a.setLevelName, setIsJavabuilderConnecting = _a.setIsJavabuilderConnecting, setIsReadOnlyWorkspace = _a.setIsReadOnlyWorkspace, setHasOpenCodeReview = _a.setHasOpenCodeReview, setCommitSaveStatus = _a.setCommitSaveStatus, setValidationPassed = _a.setValidationPassed, setHasRunOrTestedCode = _a.setHasRunOrTestedCode;
export default javalabSlice.reducer;
